import { ColDef, GridOptions } from "ag-grid-community";

/**
 * Default Grid Options - see https://stackoverflow.com/questions/47338347/ag-grid-server-side-pagination
 */
export default class DefaultGridOptions implements GridOptions {
    /**
     * Creates an instance of DefaultGridOptions.
     * @param rowHeight the row height in pixels - defaults to 45
     * @param pagination enable pagination - defaults to true
     * @param sortable enable sorting - defaults to true
     * @param filter enable filtering - defaults to true
     * @param pageSize the page size - defaults to 25
     */
    constructor(
        rowHeight = 45,
        pagination = true,
        sortable = true,
        filter = true,
        pageSize = 25
    ) {
        this.rowHeight = rowHeight;
        this.pagination = pagination;
        this.paginationPageSize = pageSize;
        this.cacheBlockSize = pageSize;

        if (pagination === false) {
            // The rowModelType of "infinite" forces pagination because of its nature:
            // https://www.ag-grid.com/javascript-grid-row-models/#infinite
            // And we cannot use other rowModelTypes because they are enterprise features.

            // Therefore, we can supress the pagination panel, set the page size to a big number
            // and it will function the same way as not having pagination.
            this.suppressPaginationPanel = true;
            this.paginationPageSize = 10000;
            this.cacheBlockSize = this.paginationPageSize;
        }

        this.defaultColDef = {
            filter: filter,
            sortable: sortable,
            resizable: true
        };
    }

    rowHeight: number;
    pagination: boolean;
    rowModelType = "infinite"; // this must be set to use server-side pagination
    /** The page size */
    paginationPageSize: number;
    /** The amount of rows that are pulled into the cache per request */
    cacheBlockSize: number;
    domLayout = "autoHeight";
    suppressPaginationPanel = false;
    defaultColDef: ColDef = {};
}
